import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Textarea,
  Typography
} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {updateWalletWithdrawal} from "../../services/wallet/wallet";
import {Toaster} from "../../helper/Toaster";
import FileInput from "../system/fileInput";
import FileCell from "../system/fileViewer";
import dict from "../../helper/dict";
import SelectInput from "../system/select";

export function AdminWithdrawalForm({withdrawal, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [bankName, setBankName] = useState("")
  const [bankCard, setBankCard] = useState("")
  const [bankSheba, setBankSheba] = useState("")
  const [value, setValue] = useState("")
  const [description, setDescription] = useState(null);
  const [receipt, setReceipt] = useState(null);
  const [initialReceipt, setInitialReceipt] = useState(null);
  const [status, setStatus] = useState(false)
  const [initialStatus, setInitialStatus] = useState("")
  const [paymentType, setPaymentType] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [factorNumber, setFactorNumber] = useState("");
  const [referenceCode, setReferenceCode] = useState("");

  useEffect(() => {
    setId(withdrawal?.id ?? null);
    setBankName(withdrawal?.bank_name ?? "")
    setBankCard(withdrawal?.bank_card ?? "")
    setBankSheba(withdrawal?.bank_sheba ?? "")
    setValue(withdrawal?.value ?? "");
    setDescription(withdrawal?.description ?? "");
    setReceipt(withdrawal?.receipt ?? null);
    setInitialStatus(withdrawal?.status ?? "")
    setStatus(
      withdrawal?.status === 'accepted' ? true :
        withdrawal?.status === 'rejected' ? false :
          false
    );
    setPaymentType(withdrawal?.payment_type ?? "")
    setInvoiceNumber(withdrawal?.invoice_number ?? "")
    setFactorNumber(withdrawal?.factor_number ?? "")
    setReferenceCode(withdrawal?.reference_code ?? "")
  }, [withdrawal]);

  const save = async (sendStatus) => {
    if (initialStatus === "accepted" || initialStatus === "rejected") {
      Toaster.failure(null,
        <Typography variant="small">
          امکان تغییر وضعیت برداشت وجود ندارد
        </Typography>);
      return
    }

    const data = {
      id: id,
      description: description,
      status: sendStatus,
      payment_type: paymentType,
      invoice_number: invoiceNumber,
      factor_number: factorNumber,
      reference_code: referenceCode,
    };
    if (receipt && sendStatus === "accepted") {
      data.receipt = receipt;
    }

    let result;

    result = await updateWalletWithdrawal(data);

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={open} size="md" handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ویرایش/جدید</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-scroll md:overflow-y-visible">

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {`نام بانک:  ${bankName}`}
              </Typography>
            }
          </div>

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {`شماره کارت:  ${persianNumberFormat(bankCard)}`}
              </Typography>
            }
          </div>

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {`شماره شبا:  ${persianNumberFormat(bankSheba)}`}
              </Typography>
            }
          </div>

          <div className=" border-b">
            {value > 0 &&
              <Typography color="blue-gray" className="flex w-full my-2">
                {"مبلغ برداشت از کیف پول: " + persianNumberFormat(value, true) + " ریال "}
              </Typography>
            }
          </div>

          <div>
            <SelectInput
              label="روش پرداخت"
              options={[
                {
                  "id": "card",
                  "title": "کارت به کارت"
                },
                {
                  "id": "direct",
                  "title": "حساب به حساب"
                },
                {
                  "id": "sheba",
                  "title": "شبا"
                },
              ]}
              onChange={setPaymentType}
            />
          </div>

          <div>
            <Input
              label="شماره پیش‌فاکتور"
              placeholder="شماره پیش‌فاکتور"
              variant="standard"
              onChange={(e) => {
                setInvoiceNumber(e.target.value)
              }}
            />
          </div>

          <div>
            <Input
              label="شماره فاکتور"
              placeholder="شماره فاکتور"
              variant="standard"
              onChange={(e) => {
                setFactorNumber(e.target.value)
              }}
            />
          </div>

          <div>
            <Input
              label="شماره سند/ کدپیگیری"
              placeholder="شماره سند/ کدپیگیری"
              variant="standard"
              onChange={(e) => {
                setReferenceCode(e.target.value)
              }}
            />
          </div>

          <div>
            {!initialReceipt &&
              <FileInput label="رسید واریز" onChange={(e) => {
                setReceipt(e.target.files[0]);
              }}/>
            }
            {initialReceipt &&
              <FileCell fileCode={receipt}/>}
          </div>

          <div>
            <Textarea
              className="w-full"
              label={`${dict('description')}`}
              variant="standard"
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
          {(initialStatus === "new") && receipt &&
            <Button variant="gradient" color="gray" onClick={() => (save("accepted"))} className="ml-1">
              <span>ثبت واریز</span>
            </Button>
          }
          {(initialStatus === "new") && !receipt &&
            <Button variant="gradient" color="gray" onClick={() => (save("rejected"))} className="ml-1">
              <span>رد درخواست</span>
            </Button>
          }
        </DialogFooter>
      </Dialog>
    </>
  );
}